import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import api from "@/lib/api";

export default function FAQ() {
    const { t } = useTranslation();
    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        api.get("/public/faqs").then((r) => setFaqs(r.data));
    }, []);

    return (
        <section className="bg-cream min-h-[70vh]">
            <div className="mx-auto max-w-4xl px-6 lg:px-10 py-16 lg:py-24">
                <div className="text-center mb-12">
                    <div className="text-xs uppercase tracking-[0.3em] text-gold-600 mb-3">
                        {t("faq.eyebrow")}
                    </div>
                    <h1 className="font-display text-5xl md:text-6xl text-navy-700">
                        {t("faq.title")}
                    </h1>
                </div>

                <div className="grid md:grid-cols-[1fr_240px] gap-10 items-start">
                    <Accordion
                        type="single"
                        collapsible
                        className="w-full bg-white rounded-2xl shadow-soft divide-y divide-navy-100/50"
                        data-testid="faq-accordion"
                    >
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                className="px-6 border-none"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-trigger-${i}`}
                                    className="text-left font-display text-lg text-navy-700 hover:text-navy-700 py-5"
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-navy-500 leading-relaxed pb-5">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>

                    <img
                        src="/panda/panda-checklist.png"
                        alt=""
                        className="hidden md:block mx-auto drop-shadow-xl"
                    />
                </div>
            </div>
        </section>
    );
}
